import ApiService from './api.service';

export default function ApplicantDashboard() {}

ApplicantDashboard.getData = (user) => {
  return ApiService.get(`/applicants/${user.id}/dashboard`);
}
